export default {
  meta: {
    title: '资产复盘'
  }
};
